import { WinningType } from "./enum/winningType";

export interface WinnerCheckInStatusListWrapperDto {
  contents: WinnerCheckInStatusListDto[];
}

export interface WinnerCheckInStatusListDto {
  winningType: string;
  winners: WinnerCheckInStatusDto[];
  totalCount: number;
}

export interface WinnerCheckInStatusDto {
  fanId: number;
  winnerId: number;
  sequenceNumber: number;
  isNoShow: boolean;
}

export class WinnerCheckInStatus {
  fanId: number;
  winnerId: number;
  orderNumber: number;
  winnerType: WinningType;
  isNoShow?: boolean;

  constructor(dto: {
    fanId: number;
    winnerId: number;
    orderNumber: number;
    winnerType: WinningType;
    isNoShow?: boolean;
  }) {
    this.fanId = dto.fanId;
    this.winnerId = dto.winnerId;
    this.orderNumber = dto.orderNumber;
    this.winnerType = dto.winnerType;
    this.isNoShow = dto.isNoShow;
  }

  static winnerCheckInStatusList(
    dto: WinnerCheckInStatusListWrapperDto,
  ): WinnerCheckInStatus[] {
    return dto.contents.flatMap((content) =>
      content.winners.map(
        (winner) =>
          new WinnerCheckInStatus({
            fanId: winner.fanId,
            winnerId: winner.winnerId,
            orderNumber: winner.sequenceNumber,
            winnerType:
              WinningType[content.winningType as keyof typeof WinningType],
            isNoShow: winner.isNoShow,
          }),
      ),
    );
  }
}
